module.exports = __webpack_public_path__ + "static/media/more-videos.953de738.jpg";